import { IN_APP_CARD_CHANGE_OPEN_STATE } from './types'

export const doChangeOpenState = (key, isOpen) => dispatch =>
  dispatch({
    type: IN_APP_CARD_CHANGE_OPEN_STATE,
    payload: { key, isOpen },
  })
